import { TFunction } from 'react-i18next';

export enum CouponType {
	IN_GAME = 'undecided',
	WON = 'won',
	ALL = 'all',
}

export const COUPON_TABS = (t: TFunction) => [
	{
		label: t('inGame'),
		value: CouponType.IN_GAME,
		cyTestRef: 'in-game-tab',
	},
	{
		label: t('wins'),
		value: CouponType.WON,
		cyTestRef: 'won-tab',
	},
	{
		label: t('history'),
		value: CouponType.ALL,
		cyTestRef: 'history-tab',
	},
];
